// import axios from "axios"

export const FETCH_OPTIONS = async dispatch => {
  try {
    // const response = await axios.get(
    //   process.env.GATSBY_WP_URL + endpoints.GLOBAL_OPTIONS
    // )
    // type: "GLOBAL",
    // dispatch({
    //   type: "GLOBAL_MENU",
    //   payload: {
    //     global: config.options.acf,
    //     menu_1: config.menu_1_header.items,
    //     menu_2: config.menu_2_login_signup.items,
    //     menu_3: config.menu_3_footer_column_1.items,
    //     menu_4: config.menu_4_footer_column_2.items,
    //   },
    // })
    // payload: response.data.acf,
  } catch (err) {}
}

export const FETCH_PAGES = async slug => {
  try {
    // const response = await axios.get(
    //   process.env.GATSBY_WP_URL + endpoints.FETCH_PAGES + "/?slug=" + slug
    // )
    // if (response.data) {
    // }
    // return response
    // dispatch({
    //   type: "PAGES",
    //   payload: response.data.acf,
    // })
  } catch (err) {}
}

export const FETCH_PRIMARY_MENUS = async dispatch => {
  try {
    // const response = await axios.get(
    //   process.env.GATSBY_WP_URL + endpoints.HEADER_MENUS + "/menu-1-header"
    // )
    // dispatch({
    //   type: "PRIMARY_MENU",
    //   payload: response.data.items,
    // })
  } catch (err) {}
}

export const FETCH_SECONDARY_MENUS = async dispatch => {
  try {
    // const response = await axios.get(
    //   process.env.GATSBY_WP_URL +
    //     endpoints.HEADER_MENUS +
    //     "/menu-2-login-signup"
    // )
    // dispatch({
    //   type: "SECONDARY_MENU",
    //   payload: response.data.items,
    // })
  } catch (err) {}
}

export const FETCH_FOOTER_MENU_ONE = async dispatch => {
  try {
    // const response = await axios.get(
    //   process.env.GATSBY_WP_URL +
    //     endpoints.HEADER_MENUS +
    //     "/menu-3-footer-column-1"
    // )
    // dispatch({
    //   type: "FOOTER_MENU_ONE",
    //   payload: response.data.items,
    // })
  } catch (err) {}
}

export const FETCH_FOOTER_MENU_TWO = async dispatch => {
  try {
    // const response = await axios.get(
    //   process.env.GATSBY_WP_URL +
    //     endpoints.HEADER_MENUS +
    //     "/menu-4-footer-column-2"
    // )
    // dispatch({
    //   type: "FOOTER_MENU_TWO",
    //   payload: response.data.items,
    // })
  } catch (err) {}
}
